








































import 'reflect-metadata'
import { Mixins, Component, Watch } from 'vue-property-decorator'
import Loader from '@/components/misc/Loader.vue'
import Blockchain from '@/js/Blockchain'
import BlockchainSummary from '@/components/Blockchain/BlockchainSummary.vue'
import { TransactionsGettersMixin } from '@/store/modules/transactions/transactions.mixins'
import { ITransactionParams } from '@/services/transactions'
import TxHeader from '@/components/Transaction/TxHeader.vue'
import TxInteractive from '@/components/Transaction/TxInteractive.vue'
import { ChainMap, getTastChainType } from '@/known_blockchains'
import QueryString from 'qs'
import Stats from '@/components/ActionChain/Stats.vue'
import RecentBlocks from '@/components/ActionChain/RecentBlocks.vue'
import RecentTransactions from '@/components/ActionChain/RecentTransactions.vue'
import { EVMBlockQueryResponse } from '@/store/modules/blocks/models'
import {
    DEFAULT_NETWORK_NAME,
    CURRENT_SUBNET,
} from '@/store/modules/network/network'

@Component({
    components: {
        Loader,
        BlockchainSummary,
        TxHeader,
        TxInteractive,
        Stats,
        RecentBlocks,
        RecentTransactions,
    },
})
export default class BlockchainPage extends Mixins(TransactionsGettersMixin) {
    loading = true
    blockchain: Blockchain | null = null
    filters: string[] = []
    initialParams = {
        sort: 'timestamp-desc',
        limit: 25,
    }
    hasMore = false
    connection: any
    recentBlocks = []
    renderComponent = false
    poller = 0 //ref
    sort = 'timestamp-desc'
    limit = 10
    breadcrumbs: any = [
        {
            text: 'Home',
            disabled: false,
            href: `?network=${DEFAULT_NETWORK_NAME}`,
        },
        {
            text: 'Blockchains',
            disabled: false,
            href: `/blockchains?network=${DEFAULT_NETWORK_NAME}`,
        },
    ]
    get currentSubnet() {
        return CURRENT_SUBNET
    }
    async mounted() {
        await this.getData()
        this.fetchTx(this.initialParams)
        this.poller = window.setInterval(() => this.pollForUpdates(), 5000)
        window.addEventListener(
            'TRANSACTION_POLLING:KILL',
            this.killPollingInterval.bind(this)
        )
        this.updateBlock()
    }
    @Watch('subnetsLoaded')
    async onSubnetsLoadedChanged() {
        await this.getData()
        this.fetchTx(this.initialParams)
    }

    @Watch('id')
    async onIDChanged() {
        await this.getData()
        await this.fetchTx(this.initialParams)
    }

    get id(): string {
        return this.$route.params.id
    }

    get chain() {
        return [getTastChainType(this.id) as ChainMap]
    }

    get assetsLoaded() {
        return this.$store.state.assetsLoaded
    }

    get subnetsLoaded() {
        return this.$store.state.Authority.subnetsLoaded
    }

    async getData() {
        const blockchains = await this.$store.state.Authority.blockchains
        this.blockchain = blockchains.find((b: Blockchain) => b.id === this.id)
        this.loading = false
    }

    get transactions() {
        return this.getTxsByBlockchain()
    }

    more(): void {
        const param: ITransactionParams = QueryString.parse(this.nextQuery)
        this.fetchTx(param)
    }
    @Watch('nextQuery')
    computeHasMore() {
        const { startTime, endTime } = QueryString.parse(this.nextQuery)
        this.hasMore =
            this.nextQuery !== '' &&
            startTime !== undefined &&
            endTime !== undefined
    }

    get nextQuery(): string {
        return this.$store.state.Transactions.blockchainTxRes.next
    }

    fetchTx(params: ITransactionParams): void {
        this.loading = true
        if (this.assetsLoaded) {
            this.$store
                .dispatch('Transactions/getTxsByBlockchain', {
                    id: null,
                    params: {
                        chainID: [this.id],
                        ...params,
                    },
                })
                .then(() => (this.loading = false))
        }
    }

    private killPollingInterval() {
        window.clearInterval(this.poller)
    }

    destroyed() {
        this.killPollingInterval()
        window.removeEventListener(
            'TRANSACTION_POLLING:KILL',
            this.killPollingInterval.bind(this)
        )
    }

    get latestBlockNumber(): string | null {
        return this.$root.$store.state.Blocks.latestBlockNumber
    }

    get blocks(): EVMBlockQueryResponse[] {
        return this.$store.state.Blocks.evmBlocks
    }

    async updateBlock() {
        if (this.assetsLoaded) {
            const top = parseInt(this.latestBlockNumber || '0')
            await this.$root.$store.dispatch('Blocks/getEVMBlocks', {
                top,
                bottom: Math.max(top - this.limit, 0),
            })
        }
    }

    pollForUpdates() {
        if (this.latestBlockNumber !== this.blocks.at(0)?.blockNumber) {
            this.updateBlock()
        }
    }
}
